import SherlockedImage from "../../../../src/posts/sherlocked/sherlocked-banner.jpg";
import * as React from 'react';
export default {
  SherlockedImage,
  React
};